import { render, staticRenderFns } from "./xcxList.vue?vue&type=template&id=802783ba&scoped=true"
import script from "./xcxList.vue?vue&type=script&lang=js"
export * from "./xcxList.vue?vue&type=script&lang=js"
import style0 from "./xcxList.vue?vue&type=style&index=0&id=802783ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802783ba",
  null
  
)

export default component.exports